/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Retention_5Inputs */

const da_privacy_retention_5 = /** @type {(inputs: Privacy_Retention_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Betaanmodninger: 12 måneder efter den seneste ændring.`)
};

/** @type {(inputs: Privacy_Retention_5Inputs) => LocalizedString} */
const en_privacy_retention_5 = da_privacy_retention_5;

/**

* @param {Privacy_Retention_5Inputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const privacy_retention_5 = /** @type {((inputs?: Privacy_Retention_5Inputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Retention_5Inputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_retention_5(inputs)
	return /** @type {LocalizedString} */ ("Betaanmodninger: 12 måneder efter den seneste ændring.")
});